import { useState } from "react";
import { toast } from "sonner";
import { ROLES } from "@/lib/constants";
import { api, errMsg } from "@/lib/api";
import { useData } from "@/context/DataContext";

export const RepRow = ({ rep, leadCount }) => {
  const { upsertRep } = useData();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(rep.name);
  const [role, setRole] = useState(rep.role);
  const [error, setError] = useState("");

  const patch = async (body, msg) => {
    try {
      const { data } = await api.patch(`/reps/${rep.id}`, body);
      upsertRep(data);
      toast.success(msg);
      return true;
    } catch (e) {
      toast.error(errMsg(e));
      return false;
    }
  };
  const save = async () => {
    if (!name.trim()) return setError("Name is required");
    if (await patch({ name: name.trim(), role }, "Rep updated")) { setEditing(false); setError(""); }
  };

  return (
    <li data-testid={`team-row-${rep.id}`} className={`flex flex-col gap-3 px-4 py-3.5 sm:flex-row sm:items-center ${rep.active ? "" : "opacity-60"}`}>
      {editing ? (
        <div className="flex flex-1 flex-col gap-2 sm:flex-row">
          <div className="flex-1">
            <input data-testid={`team-edit-name-input-${rep.id}`} value={name} onChange={(e) => { setName(e.target.value); setError(""); }} className={`inp ${error ? "inp-invalid" : ""}`} />
            {error && <p data-testid={`team-edit-error-${rep.id}`} className="field-error mt-1">{error}</p>}
          </div>
          <select data-testid={`team-edit-role-select-${rep.id}`} value={role} onChange={(e) => setRole(e.target.value)} className="inp sm:w-36">
            {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      ) : (
        <div className="flex flex-1 items-center gap-3 min-w-0">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-indigo-500/15 font-display text-sm font-bold text-indigo-300">
            {rep.name.split(" ").map((p) => p[0]).slice(0, 2).join("")}
          </span>
          <div className="min-w-0">
            <p data-testid={`team-name-${rep.id}`} className="truncate font-semibold">{rep.name}
              {rep.is_sample && <span className="sample-chip ml-2">Sample</span>}</p>
            <p className="text-xs text-slate-400"><span data-testid={`team-role-${rep.id}`}>{rep.role}</span> · {leadCount} leads · <span data-testid={`team-status-${rep.id}`}>{rep.active ? "Active" : "Inactive"}</span></p>
          </div>
        </div>
      )}
      <div className="flex gap-2">
        {editing ? (
          <>
            <button type="button" data-testid={`team-cancel-btn-${rep.id}`} onClick={() => { setEditing(false); setName(rep.name); setRole(rep.role); setError(""); }} className="btn-ghost">Cancel</button>
            <button type="button" data-testid={`team-save-btn-${rep.id}`} onClick={save} className="btn-primary">Save</button>
          </>
        ) : (
          <>
            <button type="button" data-testid={`team-edit-btn-${rep.id}`} onClick={() => setEditing(true)} className="btn-ghost">Edit</button>
            <button type="button" data-testid={`team-toggle-active-btn-${rep.id}`} className="btn-subtle"
              onClick={() => patch({ active: !rep.active }, rep.active ? `${rep.name} deactivated` : `${rep.name} reactivated`)}>
              {rep.active ? "Deactivate" : "Reactivate"}
            </button>
          </>
        )}
      </div>
    </li>
  );
};
